<template>
    <div>
        <top_box :return_="true" :user_data="user_data"></top_box>
        <div class="main">
            <div class="box">
				<!-- 返回首页 -->
                <div class="return_box pointer" @click="return_">
                    <img src="../../static/return_icon.png" alt="">
                    <span>{{$t('m.PlaceOrder_01')}}</span>
                </div>
                <div class="goos_status">
					
					
					<div class="goos_left" v-if="order.order_status == 0 || order.order_status == 1 || order.order_status == 2 || order.order_status == 3">
					    <h2>{{$t('m.order_state1')}}</h2>
					    <p>{{$t('m.order_state_txt1')}}</p>
					</div>
					<div class="goos_left" v-if="order.order_status == 4 || order.order_status == 5 || order.order_status == 6">
					    <h2>{{$t('m.order_state2')}}</h2>
					    <p>{{$t('m.order_state_txt2')}}</p>
					</div>
                    <div class="goos_left" v-if="order.order_status == 7">
                        <template v-if="order.shipping_status == 0 || order.shipping_status == 2">
                            <h2>{{$t('m.order_state3')}}</h2>
                            <p>{{$t('m.order_state_txt3')}}</p>
                        </template>
                        <template v-if="order.shipping_status == 1">
                            <h2>{{$t('m.order_state4')}}</h2>
                            <p>{{$t('m.order_state_txt4')}}</p>
                        </template>
                    </div>
                    <div class="goos_left" v-if="order.order_status == 8">
                        <h2>{{$t('m.order_state5')}}</h2>
                    </div>
                    <div class="goos_left" v-if="order.order_status == 9">
                        <h2>{{$t('m.order_state6')}}</h2>
                        <p>{{$t('m.order_state_txt6')}}</p>
                    </div>
					
					
                    <div class="goos_right">
                        <div class="btnbox pointer" @click="Receiving_show = true" v-if="btn.confirm == 1">
                        
                            <span>{{$t('m.order_info_01')}}</span>
                        </div>
                        <div class="btnbox pointer" @click="Receiving_show1 = true" v-if="btn.cancel == 1">
                            <span>{{$t('m.order_info_02')}}</span>
                        </div>
                        <div class="btnbox1 pointer" @click="word_down(order.id)"  v-if="btn.download == 1">
                            <span>{{$t('m.order_info_03')}}</span>
                        </div>
                    </div>
                </div>

                <div class="address flex f-ct" v-if="order.address">
					<p>{{$t('m.PlaceOrder_06')}}：{{ order.name }}</p>
					<p>{{$t('m.home_13')}}：{{ order.mobile}}</p>
                    <p>{{$t('m.home_12')}}：{{ order.address }}</p>
                </div>
				<div class="address" v-else>
					{{$t('m.PlaceOrder_066')}}
                </div>
				<!-- 订单详情 -->
                <div class="title">{{$t('m.PlaceOrder_02')}}</div>
				<!-- PC版本 -->
                <div class="tableDatabox" v-for="(item, index) in tableData" :key="index">
                    <div class="tablemain">
                        <el-table :data="[item]" border style="width: 100%">
							<template slot="empty">
								<el-empty :image-size="100" :description="$t('m.new_txt3')"></el-empty>
							</template>
							<el-table-column :label="$t('m.MallCenter_08')" prop="chart">
                                <template slot-scope="scope">
                                    <el-image class="pointer" style="width: 60px; height: 56px" :src="scope.row.img"
                                        :preview-src-list="[scope.row.img]">
                                    </el-image>
                                </template>
                            </el-table-column>
                            <el-table-column :label="$t('m.MallCenter_09')" prop="goods_name"></el-table-column>
                            <el-table-column :label="$t('m.MallCenter_10')" prop="cat_name"></el-table-column>
                            <el-table-column :label="$t('m.MallCenter_12')" prop="model"></el-table-column>
                            <el-table-column :label="$t('m.PlaceOrder_09')" prop="goods_amount_rmb"></el-table-column>
                            <el-table-column :label="$t('m.PlaceOrder_10')" prop="goods_amount_dollar"></el-table-column>
                        </el-table>
                    </div>
                    <div class="table_info" style="margin-top: 40px;border-top: 1px solid #eee;">
                        <el-table :data="[item][0].spec" border style="width: 100%" :header-cell-style="{ background: '#fbfcfe', color: '#2e3341', fontWeight: '400' }">
                            <el-table-column :label="$t('m.PlaceOrder_07')" prop="spec_key_name"></el-table-column>
                            <el-table-column :label="$t('m.PlaceOrder_08')" prop="goods_num"></el-table-column>
                            <el-table-column :label="$t('m.PlaceOrder_099')" prop="price_rmb"></el-table-column>
                            <el-table-column :label="$t('m.PlaceOrder_100')" prop="price_dollar"></el-table-column>
                        </el-table>
                    </div>
                </div>

				
				
				
				<!-- h5的表 -->
				<div class="tableDatabox_h5">
					<!-- 其他信息 -->
					<div class="other_box" v-if="tableData" v-for="(item,index) in tableData" :key="index">
						<p class="tit"></p>
						<div class="item_o">
							<div class="status flex f-ct f-bt">
								<p>-{{$t('m.shoping_txt1')}}</p>
							</div>
							<div class="goods flex">
								<div class="l">
									<img :src="item.img" alt="">
								</div>
								<div class="r">
									<div class="tbox1 flex f-ct f-bt">
										<p class="line2">{{item.goods_name}}</p>
									</div>
									<div class="tbox2 flex f-ct f-bt">
										<p>{{$t('m.MallCenter_10')}}：{{item.cat_name}}</p>
										<p style="opacity: 0;">x1</p>
									</div>
								</div>
							</div>
						</div>
						<div class="item flex f-ct f-bt">
							<p>{{$t('m.MallCenter_12')}}</p>
							<p>{{item.model}}</p>
						</div>
						<div class="item flex f-ct f-bt">
							<p>{{$t('m.PlaceOrder_09')}}</p>
							<p>￥{{item.goods_amount_rmb}}</p>
						</div>
						<div class="item flex f-ct f-bt">
							<p>{{$t('m.PlaceOrder_10')}}</p>
							<p>${{item.goods_amount_dollar}}</p>
						</div>
						<!-- 规格部分 -->
						<div class="ggbox">
							<div class="gg_box" v-for="(gg_item,gg_index) in item.spec" :key="gg_index">
								<div class="item_gg1 flex f-ct" @click="changradio(item,gg_index)">
									<p>{{gg_item.spec_key_name}}</p>
								</div>
								<div class="item_gg2 flex f-ct f-bt">
									<p>{{$t('m.PlaceOrder_08')}}</p>
									<p>{{$t('m.PlaceOrder_099')}}</p>
									<p>{{$t('m.PlaceOrder_100')}}</p>
								</div>
								<div class="item_gg2 flex f-ct f-bt">
									<div>
										<div style="opacity: 0;" class="pointer btnbox flex f-ct f-btc">
											<span>－</span>
										</div>
										<div class="inpunumber">
										    <el-input v-model="gg_item.goods_num" ></el-input>
										</div>
										<div style="opacity: 0;" class="pointer btnbox flex f-ct f-btc">
											<span>＋</span>
										</div>
									</div>
									<p>￥{{gg_item.price_rmb}}</p>
									<p>${{gg_item.price_dollar}}</p>
								</div>

							</div>
						</div>
					</div>	
				
				</div>
				
				<!-- 订单号 -->
				<div class="title" style="display: block;">{{$t('m.wl_tit')}}</div>
				<div class="tableDatabox" style="display: block;" v-for="(item, index) in 1" :key="index">
				    <div class="table_info" style="margin-top: 40px;border-top: 1px solid #eee;">
				        <el-table :data="wl_arr" border style="width: 100%" :header-cell-style="{ background: '#fbfcfe', color: '#2e3341', fontWeight: '400' }">
				            <el-table-column :label="$t('m.wl_txt1')" prop="add_time"></el-table-column>
				            <el-table-column :label="$t('m.wl_txt2')" prop="express_name"></el-table-column>
				            <el-table-column :label="$t('m.wl_txt3')" prop="shipping_sn"></el-table-column>
				            <el-table-column :label="$t('m.wl_txt4')">
								<template slot-scope="scope">
									<div style="cursor: pointer;" @click="hb_wl_f(scope.row)">{{$t('m.wl_txt5')}}</div>
								</template>
							</el-table-column>
				        </el-table>
				    </div>
				</div>
				<!-- 订单号 商品 弹出框 -->
				<div class="hb_bg" @click="hb_wl = false" v-if="hb_wl"></div>
				<div class="hb_wl" v-if="hb_wl">
					<div class="tit">{{$t('m.wl_txt6')}}</div>
					<div class="goodsbox">
						<p v-for="(item,index) in wlgoods_list">{{item.goods_name}}</p>
					</div>
				</div>
				
				<!-- 订单信息 -->
                <div class="info">
                    <div class="info_left">
                        <span> ——</span> {{$t('m.order_info_04')}}：
                    </div>
                    <div class="info_right">
						<span>
							<span>{{$t('m.order_info_05')}}：</span>{{ order.order_amount_rmb }}
						</span>
						<span class="number">
							<span>{{$t('m.Myorder_08')}}：</span>{{ order.order_sn }}
						</span>
						<span>
							<span>{{$t('m.order_info_06')}}：</span>${{ order.order_amount_dollar }}
						</span>
						<span class="number">
							 <span>{{$t('m.Myorder_12')}}：</span>{{ order.add_time }}
						</span>
						
						<span v-if="order.msg">
							<span >{{$t('m.PlaceOrder_03')}}：</span>{{order.msg}}
						</span>
						<span v-else>
							<span >{{$t('m.PlaceOrder_03')}}：</span>{{$t('m.new_txt4')}}
						</span>
						
						<span class="number" v-if="order.cancel_time">
							 <span>{{$t('m.Myorder_122')}}：</span>{{ order.cancel_time}}
						</span>	
						<span class="number" v-if="order.give_price_time">
							 <span>{{$t('m.Myorder_1222')}}：</span>{{ order.give_price_time}}
						</span>
	
						<span class="number" v-if="order.shipping_status*1">
							 <span>{{$t('m.Myorder_12222')}}：</span>{{ order.delivery_time}}
						</span>
                    </div>
                </div>
				
				
            </div>
        </div>
		
		
		
        <el-dialog :visible.sync="Receiving_show" width="350px" :show-close="false" center>
            <div class="showbox">
                <div class="title">{{$t('m.order_info_01')}}</div>
                <p>{{$t('m.order_info_07')}}</p>
                <div class="btnboxli">
                    <div class="btnbox1 pointer" @click="Receiving_show = false">
                        <span>{{$t('m.address_08')}}</span>
                    </div>
                    <div class="btnbox pointer" @click="confirm()">
                        <span>{{$t('m.order_info_01')}}</span>
                    </div>
                </div>
            </div>
        </el-dialog>

        <el-dialog v-if="Receiving_show1" :show-close="false" :visible.sync="Receiving_show1" width="350px" center>
            <div class="showbox">
                <div class="title">{{$t('m.order_info_02')}}</div>
                <p>{{$t('m.order_info_08')}}？</p>
                <div class="btnboxli">
                    <div class="btnbox1 pointer" @click="Receiving_show1 = false">
                        <span>{{$t('m.address_08')}}</span>
                    </div>
                    <div class="btnbox pointer" @click="confirm1()">
                        <span>{{$t('m.order_info_09')}}</span>
                    </div>
                </div>
            </div>

        </el-dialog>
		
		
		<a class="downloadUrl" v-show="false" :href="downloadUrl" target="_blank" ref="downloadUrl"></a>
    
		
		<div class="loding" v-if="loding">加载中</div>
	</div>
</template>
<script>
import top_box from '../../components/header_top'
import encryption from '@/utils/encryption.js'
export default {
    components: {
        top_box,

    },
    data() {
        return {
            downloadUrl: "",
            order_id: "",
            srcList: [
                'https://fuss10.elemecdn.com/8/27/f01c15bb73e1ef3793e64e6b7bbccjpeg.jpeg',

            ],
            order: {},
            user_data: {},
            Receiving_show: false,
            Receiving_show1: false,
            btn: {},
            tableData: [],
			// 物流单号列表
			wl_arr:[],
			hb_wl:false,
			wlgoods_list:[],
			// 是否英文
			is_en:'false',
			loding:false,
        }
    },
    mounted() {
		this.is_en = this.$t('m.is_en')
        this.order_id = this.$route.query.order_id
        let user_data = JSON.parse(localStorage.getItem('user_data'))
        this.user_data = user_data
        this.getData()
    },
    methods: {
		// 打开物流列表商品详情
		hb_wl_f(item){
			let param = {
			    user_id: this.user_data.id,
			    shipping_log_id: item.id,
			}
			this.loding = true
			let sing = encryption.getSing(param)
			this.$api.shippinglog_details(param,sing).then((res) => {
				if(res.data.code == 1){
					if(this.is_en==='true'){
						for(var i in res.data.data.shipping_log_detail){
							res.data.data.shipping_log_detail[i].goods_name = res.data.data.shipping_log_detail[i].goods_name_en
						}
					}
					this.wlgoods_list = res.data.data.shipping_log_detail
					this.hb_wl = true
				}
				this.loding = false
			})
			
		},
		// 文件下载
		word_down(id){
			let param = {
			    user_id: this.user_data.id,
			    order_id: id,
			}
			let sing = encryption.getSing(param)
			
			var _this = this
			this.$api.get_worddown(param,sing).then((res) => {
				if(res.data.code == 1){
					_this.downloadUrl = res.data.data;
					setTimeout(function(){
						_this.$refs.downloadUrl.dispatchEvent(new MouseEvent('click'))
					},100)
				}
			})
		},
        getData() {
            let param = {
                user_id: JSON.parse(localStorage.getItem('user_data')).id || '',
                order_id: this.order_id
            }
            let sing = encryption.getSing(param)
            this.$api.order_details(param, sing).then((res) => {
                if (res.data.code == 1) {
                    this.tableData = res.data.data.goods_list || []
                    let order = res.data.data.order
                    order.add_time = this.$common.timetrans(order.add_time, true, '-', '-', '')
					if(order.cancel_time){	
						order.cancel_time = this.$common.timetrans(order.cancel_time, true, '-', '-', '')
					}
					if(order.give_price_time){	
						order.give_price_time = this.$common.timetrans(order.give_price_time, true, '-', '-', '')
					}
					if(order.delivery_time){	
						order.delivery_time = this.$common.timetrans(order.delivery_time, true, '-', '-', '')
					}
                    this.order = order
                    this.btn = res.data.data.btn
					
					for(var i in res.data.data.shipping_log){
						res.data.data.shipping_log[i].add_time = this.nowtime(res.data.data.shipping_log[i].add_time*1000)
						if(this.is_en  === 'true'){
							res.data.data.shipping_log[i].express_name = res.data.data.shipping_log[i].express_name_en
							
						}
					}
					
					this.wl_arr = res.data.data.shipping_log
					console.log(this.wl_arr)
                }
            })
        },
		// 获取当前时间/时间格式化
		nowtime:(time) => {
			var date
			if (time) {date = new Date(time);} else {date = new Date();}
			var year = date.getFullYear(),
				month = date.getMonth() + 1,
				day = date.getDate(),
				hour = date.getHours() < 10 ? "0" + date.getHours() : date.getHours(),
				minute = date.getMinutes() < 10 ? "0" + date.getMinutes() : date.getMinutes(),
				second = date.getSeconds() < 10 ? "0" + date.getSeconds() : date.getSeconds();
				month >= 1 && month <= 9 ? (month = "0" + month) : "";
				day >= 0 && day <= 9 ? (day = "0" + day) : "";
			// var timer = {
			// 	year: year,
			// 	month: month,
			// 	day: day,
			// 	hour: hour,
			// 	minute: minute,
			// 	second: second,
			// }
			var timer = year+'-'+month+'-'+day
			return timer;
		},
        confirm() {
            let param = {
                user_id: JSON.parse(localStorage.getItem('user_data')).id || '',
                order_id: this.order_id
            }
            let sing = encryption.getSing(param)
			// this.Receiving_show = false
			// console.log(this.Receiving_show1)
			// return
            this.$api.order_confirm(param, sing).then((res) => {
                if (res.data.code == 1) {
                    this.$message({
                        type: 'success',
                        message: this.$t('m.order_info_10')
                    });
                    this.Receiving_show = false
                    this.getData()
                }
            })
        },
        //取消订单
        confirm1() {
            let param = {
                user_id: JSON.parse(localStorage.getItem('user_data')).id || '',
                order_id: this.order_id
            }
            let sing = encryption.getSing(param)
            this.$api.order_cancel(param, sing).then((res) => {
                if (res.data.code == 1) {
                    this.$message({
                        type: 'success',
                        message: this.$t('m.order_info_11')
                    });
                    this.Receiving_show1 = false
                    this.getData()
                }
            })

        },
        address_() {
            console.log(111)
            this.$router.push({
                path: '/user/address'
            })
        },
        return_() {
            this.$router.go(-1)
        },
        Submit() {
            this.$router.push('/Submit')
        }
    }

}
</script>
<style lang="scss" scoped>
// .box{
//     min-width: 800px;
// }
.loding{
	width: 200px;
	height: 100px;
	background: rgba(0, 0, 0, 0.6);
	border-radius: 8px;
	color: #fff;
	text-align: center;
	line-height: 100px;
	position: fixed;
	top: 50%;
	left: 50%;
	transform: translateY(-50%)translateX(-50%);
	font-size: 18px;
}
.Price {
    padding: 40px 0;
    display: flex;
    align-items: center;
    justify-content: space-between;

    .Price_left {
        padding-left: 20px;
        font-size: 14px;
        font-weight: bold;


        p {


            span {
                font-size: 18px;
                font-weight: bold;

            }

            .rmb {
                color: #ef5843;
            }

        }
    }

    ::v-deep .el-button {
        background-color: #ef5843;
        width: 185px;
        height: 60px;
        font-weight: bold;
        font-size: 15px;

    }
}



.main {
    background-color: #fff;
    width: 100%;
    margin-top: 13px;
    padding: 20px 0;
	padding-bottom: 140px;
    .box {
        width: 62%;


        margin: 0 auto;

        .return_box {
            display: flex;
            align-items: center;


            span {
                margin-left: 10px;
                font-size: 14px;
            }
        }

        .address {
            width: 100%;
            background-color: #f6f7fa;
            height: 60px;
            margin-top: 20px;
            border: 1px solid #eff1f6;
            display: flex;
            align-items: center;
            padding: 0 40px;

            justify-content: space-between;

            .address_left {
                display: flex;
                align-items: center;

                font-size: 14px;

                .text2 {
                    color: #005efc;
                    font-size: 14px;
                    margin-left: 20px;
                }
            }
        }
    }
}

.title {
    font-weight: bold;
    margin-top: 20px;
    font-size: 18px;
	padding: 10px 40px;
}

.tableDatabox {
    margin-top: 20px;
    width: 100%;

    ::v-deep .table_info {
        .el-table tr {
            background-color: #fbfcfe !important;
        }
    }
}




.el-form--inline .el-form-item {
    width: 100%;

}

::v-deep .el-form--inline .el-form-item__content {
    width: 100% !important;
}

.commodity_info {
    width: 100%;
    display: flex;
    align-items: center;

    .Selected_style {
        background-color: #ef5843 !important;
    }

    .ridio {
        width: 20px;
        height: 20px;
        border-radius: 50%;
        margin-right: 10px;
        margin-left: 300px;

        text-align: center;
        line-height: 20px;

        img {
            width: 12px;
            height: 9px;
        }
    }


}






.user_box {
    display: flex;
    align-items: center;
    justify-content: space-between;
    border-left: 5px solid #ef5843;
    height: 26px;
    padding-right: 30px;

    .user_box_left {
        padding-left: 25px;
    }

}

.search {
    margin-top: 30px;
    width: 100%;
    padding: 0 30px;
}

.classification {
    margin-top: 20px;
    display: flex;
    align-items: center;
    padding: 0 30px;

    .item {
        margin-left: 30px;
    }
}



.pagingbox {
    padding: 0 30px;
    margin-top: 30px;
    display: flex;
    justify-content: flex-end;
    align-items: center;
}

::v-deep.el-table th.el-table__cell {
    background-color: #e9ecf2;
    color: #000000;
}

.el-table ::v-deep.el-table__cell {
    text-align: center;
}

::v-deep .el-table--border .el-table__cell,
.el-table__body-wrapper .el-table--border.is-scrolling-left~.el-table__fixed {
    border-right: 0 !important;
}

::v-deep .el-image {

    border-radius: 5px;
}

::v-deep .el-table--border {
    border-top: none;
}

.showbox {
    padding: 30px;
    background-color: #fff;
    border-radius: 4px;

    .bar {
        font-weight: bold;
        text-align: center;
    }

    .title {
        font-size: 24px;
        font-weight: bold;
        text-align: center;
        margin-top: 0 !important;

    }

    p {
        margin-top: 10px;
        text-align: center;
    }

    .btnboxli {
        display: flex;
        align-items: center;
        justify-content: center;
        margin-top: 40px;


        .btnbox {
            background-color: #ef5843;
            height: 54px;
            min-width: 120px;
			padding: 0 20px;
            display: flex;
            align-items: center;
            color: #fff;
            border-radius: 4px;
            justify-content: center;
            margin-left: 20px;
			text-align: center;
            span {
                font-weight: bold;
            }

        }

        .btnbox1 {
            background-color: #fff;
            color: #ef5843;
            border: 3px solid #ef5843;
            border-radius: 4px;
            height: 54px;
            min-width: 120px;
            padding: 0 20px;
			text-align: center;
            span {
                font-weight: bold;
            }
            display: flex;
            align-items: center;
            justify-content: center;


        }
    }
}




.goos_status {
    margin-top: 25px;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
	padding: 20px 40px;
    p {
        margin-top: 10px;
        font-size: 14px;
    }

    .goos_right {
        display: flex;
        align-items: center;

        .btnbox {
            background-color: #ef5843;
            height: 54px;
            min-width: 120px;
            padding: 0 20px;
            display: flex;
            align-items: center;
            color: #fff;
            border-radius: 4px;
            justify-content: center;
            font-weight: bold;
            font-size: 15px;

        }

        .btnbox1 {
            background-color: #fff;
            color: #ef5843;
            border: 3px solid #ef5843;
            border-radius: 4px;
            height: 54px;
            min-width: 120px;
            padding: 0 20px;
            margin-left: 14px;
            display: flex;
            align-items: center;
            font-weight: bold;
            justify-content: center;
            font-size: 15px;


        }
    }
}

.info {
    background-color: #fbfcfe;
    border: 1px solid #e5e5e5;
    display: flex;
    border-radius: 4px;
    padding: 30px;
    margin-top: 30px;
	justify-content: space-between;
    .info_left {
        span {
            color: #f17160;
        }

        width: 50%;

        font-weight: bold;
        font-size: 20px;
    }

    .info_right {
        width: 60%;
        font-size: 14px;
		display: flex;
		align-items: center;
		flex-wrap: wrap;
		
		>span{
			width: 50%;
			padding: 10px 0;
			// margin-bottom: 10px;
			// text-align: right;
			display: flex;
			align-items: center;
			span{
				display: block;
				width: 100px;
			}
		}
    }

    .info_item1 {
        margin-top: 0 !important;
    }

    .info_item {
        width: 100%;
        display: flex;
        justify-content: space-between;

        align-items: center;
        margin-top: 20px;

        .title {
            font-weight: bold;
            font-size: 20px;
            width: 40%;
        }

        .text {
            display: flex;
            align-items: center;
            justify-content: space-between;
            width: 60%;

            .number {
				
			}
        }
    }
}
.number{
	// display: flex;
	// align-items: center;
	// span{
	// 	width: 120px;
	// 	display: block;
	// }
}

::v-deep .el-dialog__header {
    padding: 0 !important;
}

::v-deep .el-dialog__body {
    padding: 0 !important;
}

::v-deep .el-dialog {
    margin-top: 35vh !important;
    border-radius: 4px;
    border-top: 5px solid #ef5843;
}



.tableDatabox_h5{
	display: none;
}
// 宽度小于1200px
@media screen and (max-width: 1200px){
	.main{
		padding: 0;
		.box{
			width: 100%;
			padding: 1rem 0.8rem;
			.goos_status{
				padding: 0;
				.goos_right{
					text-align: center;
				}
			}
			.address{
				height: auto;
				padding: 0.8rem;
				display: block;
				p{
					margin: 0.2rem 0;
					font-size: 14px;
					// margin-right: 10px;
				}
			}
			.title{
				padding: 0;
			}
			.info{
				padding: 0.5rem;
				display: block;
				.info_left{
					width: 100%;
				}
				.info_right{
					display: block;
					width: 100%;
					>span{
						width: 100%;
						span{
							width: auto;
						}
					}
				}
			}
			.tableDatabox{
				display: none;
			}
			.tableDatabox_h5{
				display: block;
				.other_box{
					background: #fff;
					margin: auto;
					margin-top: 0.875rem;
					padding-top: 0;
					.tit{
						font-size: 0.9rem;
						font-weight: 600;
						border-bottom: 0.025rem solid #dddddd;
					} 
					.status{
						margin-top: 0.5rem;
						p{
							font-size: 0.55rem;
							font-weight: 600;
							color: #ef5843;
						}
					}
					.item_o{
						border-radius: 0.2rem;
						min-height: 5.825rem;
						background: #fff;
						margin: auto;
						padding-top: 0.075rem;
						padding-bottom: 1rem;
						.tips{
							padding-top: 0.9rem;
							padding-bottom: 0.2rem;
							font-size: 0.3rem;
							font-weight: 600;
							&:last-child{
								padding-top: 0.2rem;
							}
							input{
								width: 85%;
								text-align: right;
								font-size: 0.6rem;
								&::placeholder{
									color: #b9babb;
								}
							}
						}
						.goods{
							margin-top: 0.5rem;
							.l{
								width: 4.175rem;
								height: 3.95rem;
								margin-right: 0.6rem;
								img{
									width: 4.175rem;
									height: 3.95rem;
									border-radius: 0.2rem;
								}
							}
							.r{
								width: calc(100% - 3.775rem);
								.tbox1{
									p{
										font-size: 0.70rem;
										font-weight: 600;
									}
								}
								.tbox2{
									margin-top: 0.4rem;
									p{
										font-size: 0.6rem;
										color: #7d7d89;
									}
								}
							}
						}
					}
					.item{
						margin-bottom: 0.275rem;
						p{
							font-size: 0.6rem;
							&:first-child{
								width: 35%;
								font-size: 0.6rem;
								font-weight: 600;
							}
							&:last-child{
								width: 65%;
								text-align: right;
							}
						}
					}
					.ggbox{
						background: rgba(233, 236, 242, 0.4);
						padding:  0.3rem 0.5rem;
						margin-top: 1rem;
						border-radius: 0.2rem;
						.tit2{
							font-size: 0.9rem;
							font-weight: 600;
							padding: 0.6rem 0rem;
						} 
						.gg_box{
							padding: 0.2rem 0;
							.item_gg1{
								padding: 0.2rem 0;
								font-size: 0.6rem;
								text-align: center;
								margin-bottom: 0.1rem;
								div{
									display: flex;
									align-items: center;
									justify-content: center;
									border-radius: 50%;
									width: 1rem;
									height: 1rem;
									background: #ecedf0;
									margin-right: 1rem;
									img{
										width: 0.5rem;
										height: 0.5rem;
									}
								}
								.active{
									background: #ef5843;
								}
							}
							.item_gg2{
								padding: 0.2rem 0;
								div{
									display: flex;
									align-items: center;
									justify-content: center;
									width: 25%;
									.btnbox {
									    border-radius: 3px;
									    border: 2px solid #e5e5e5;
									    width: 40px;
									    height: 24px;
									    line-height: 24px;
									    font-weight: bold;
									}
									.inpunumber {
									    ::v-deep .el-input__inner {
									        border: 0 !important;
									        padding: 0 !important;
									        width: 30px;
									        text-align: center;
											background: none;
									    }
									}
								}
								p{
									font-size: 0.6rem;
									text-align: center;
									width: calc(75%/2);
									&:first-child{
										width: 25%;
									}
								}
							}
						}
					}
				}
			}
			.Price{
				display: block;
				.Price_right{
					margin-top: 0.8rem;
					::v-deep .el-button{
						margin: auto;
						display: block;
					}
				}
			}
		}
	}
}
.hb_bg{
	position: fixed;
	top: 0;
	left: 0;
	background: rgba(0, 0, 0, 0.4);
	width: 100%;
	height: 100%;
	z-index: 10;
}
.hb_wl{
	width: 15rem;
	// height: 10rem;
	background: #fff;
	border-radius: 12rpx;
	position: fixed!important;
	z-index: 11;
	top: 50%;
	left: 50%;
	padding-bottom: 20px;
	transform: translateX(-50%)translateY(-50%);
	.tit{
		border-top: 4px solid #ef5843;
		text-align: center;
		line-height: 40px;
		font-size: 18px;
		font-weight: 600;
		padding-top: 10px;
		margin-bottom: 5px;
	}
	.goodsbox{
		padding: 0 20px;
		max-height: 8rem;
		overflow-y: scroll;
		p{
			font-weight: 500;
			font-size: 16px;
			padding: 2px 0;
			text-align: center;
		}
	}
}
</style>